export type LaunchDarklyBooleanFlagKey =
  | 'ai_image_generation_model'
  | 'ai_video_generation_model'
  | 'allow_ai_prompts_in_canvas_text'
  | 'allow_bulk_actions_canvases_files'
  | 'allow_content_grid_autofill'
  | 'allow_canvas_duplication'
  | 'allow_canvases_tables_columns_settings'
  | 'allow_table_column_resizing'
  | 'allow_creating_canvas_with_no_template'
  | 'allow_dynamic_data_table_for_scribble_component'
  | 'allow_html_for_scribble_component'
  | 'allow_embeddable_for_scribble_component'
  | 'allow_embeddable_hiding'
  | 'allow_multimedia_for_scribble_component'
  | 'allow_note_taking'
  | 'allow_rep_canvas_metadata_edit'
  | 'allow_rep_file_distributions'
  | 'allow_rep_file_rating'
  | 'allow_rep_file_upload'
  | 'allow_saving_annotations_in_personal_layer'
  | 'allow_user_to_edit_font_size_and_color_in_canvas_tokens'
  | 'are_sections_system_controlled'
  | 'enable_canvas_core_distributions'
  | 'copy_context_to_canvas'
  | 'copy_template_metadata_to_canvas'
  | 'disable_canvas_edit_for_reps'
  | 'disable_custom_tooltips'
  | 'disable_file_edit_content'
  | 'enable_inline_wopi_edit_button'
  | 'disable_fullscreen_canvas_builder'
  | 'disable_impact_web_browser_fullscreen'
  | 'disable_user_invitations'
  | 'display_section_list_name'
  | 'disable_download_canvas'
  | 'enable_ai_generated_thumbnails'
  | 'enable_analytics'
  | 'enable_app_developer_role'
  | 'enable_algolia_search'
  | 'enable_background_image_theme_options'
  | 'enable_better_canvas_builder_control_bars_on_zoom'
  | 'enable_bulk_update_file_attributes'
  | 'enable_canvas_as_home'
  | 'enable_canvas_blocks'
  | 'enable_canvas_node_debugging'
  | 'enable_canvas_freeze'
  | 'enable_canvas_locks'
  | 'enable_canvas_template_edit_in_impact'
  | 'enable_canvas_tokens'
  | 'enable_collaborations'
  | 'enable_collection_player_data_accessor'
  | 'enable_content_grid_data_accessor'
  | 'enable_content_type_change_in_content_selector'
  | 'enable_cross_tab_instance_reload_for_ld_sync'
  | 'enable_create_section_from_section_template'
  | 'enable_custom_display_overrides'
  | 'enable_default_crm_shape'
  | 'enable_detailed_date_format'
  | 'enable_dsr_readonly_annotations'
  | 'enable_dnd_html_editor'
  | 'enable_dynamic_content_component'
  | 'enable_dynamic_data_table_component'
  | 'enable_custom_data_tables'
  | 'enable_embedded_video_autoplay'
  | 'enable_embedded_video'
  | 'enable_enhanced_canvas_drawer_app'
  | 'enable_enhanced_indicators'
  | 'enable_enhanced_section_execution_states'
  | 'enable_experimental_canvas_builder_dnd'
  | 'enable_extra_file_data'
  | 'enable_file_copy'
  | 'enable_file_pages_metadata'
  | 'enable_file_revisions'
  | 'enable_file_divisible_permission'
  | 'enable_folder_details_edit'
  | 'enable_folder_distributions'
  | 'enable_handlebar_template_support'
  | 'enable_height_in_component_theming'
  | 'enable_home_customization'
  | 'enable_hotspot_visibility'
  | 'enable_improved_canvas_node_updating'
  | 'enable_individual_users_in_file_distribution'
  | 'enable_inline_filter_options'
  | 'enable_insearch_in_section_selector'
  | 'enable_instance_cloner'
  | 'enable_advanced_cloner'
  | 'enable_content_promotion'
  | 'enable_instance_editor_role'
  | 'enable_instance_navigation_from_management'
  | 'enable_knock_notifications'
  | 'enable_maintain_section_theme_control'
  | 'enable_metadata_in_file_uploads_with_default_values'
  | 'enable_more_intuitive_component_spacing'
  | 'enable_multi_destination_upload'
  | 'enable_multimedia_component_ai_images'
  | 'enable_new_meeting_bar'
  | 'enable_provider_agnostic_meeting_bar'
  | 'enable_original_pdf_link'
  | 'enable_scale_content'
  | 'enable_sorting_in_tiptap_table'
  | 'enable_theme_assets'
  | 'enable_toc_enhancements_to_support_same_section_in_section_list'
  | 'enable_pia_assistant'
  | 'enable_pipe_character_multi_search'
  | 'enable_popup_apps'
  | 'enable_pre_send_validation'
  | 'enable_reorder_search'
  | 'enable_reorder_scribble_isolation'
  | 'enable_reorder_component_options_menu'
  | 'enable_resizable_multimedia_component'
  | 'enable_responsive_scribble_component'
  | 'enable_saved_canvases_filters'
  | 'enable_short_tag_column_in_tables'
  | 'enable_scribble_component'
  | 'enable_scribble_content_as_background'
  | 'enable_search_and_filters_in_multimedia_component'
  | 'enable_section_context_in_dsr'
  | 'enable_selectors_dnd'
  | 'enable_section_selector_edit_section'
  | 'enable_smart_folders'
  | 'enable_smart_folders_for_sections'
  | 'enable_smart_folders_in_section_selector'
  | 'enable_smart_folders_in_files'
  | 'enable_sorting_in_sections'
  | 'enable_suggested_tags'
  | 'enable_template_component_permissions'
  | 'enable_template_folders'
  | 'enable_theme_options_border_radius'
  | 'enable_themes'
  | 'hide_asset_uploader'
  | 'hide_user_feedback_widget'
  | 'include_files_content_in_print'
  | 'interpolate_rep_canvases_on_edit_mode'
  | 'is_timeline_component_allowed'
  | 'launch_in_full_screen_on_present_mode'
  | 'prefer_online_handlers'
  | 'restrict_owned_files_from_admins'
  | 'show_asset_manager_for_multimedia'
  | 'show_clear_all_annotations_button'
  | 'show_content_selector_list_view'
  | 'show_metadata_filters_in_all_canvas_things'
  | 'show_only_preview_mode_for_html_component'
  | 'show_popularity_icons'
  | 'use_core_endpoint_for_analytics'
  | 'convert_pptx_to_section_with_scribble_pdfjs'
  | 'use_short_url_for_shared_link'
  | 'use_zoho_instead_of_ms_wopi'
  | 'enable_new_section_list'
  | 'enable_sharebox_apps'
  | 'enable_sharebox_bulk_filtering'
  | 'enable_back_to_previous_location_in_canvas'
  | 'enable_crm_shape_for_external_links'
  | 'enable_adaptive_popup_apps'
  | 'enable_file_version_polling'
  | 'skip_pspdfkit_wait_for_high_res_thumbs'
  | 'enable_reactive_scribble_component_toolbar'
  | 'enable_embeddable_full_screen_mode'
  | 'enable_enhanced_user_management'
  | 'enable_impersonation'
  | 'enable_instance_admin_user_assignment'
  | 'keep_static_pptx_editable'
  | 'enable_canvas_pdf_dimensions'
  | 'enable_editable_pptx_of_canvas'
  | 'enable_editable_pptx_of_canvas_with_fonts'
  | 'enable_aspose_pptx_of_canvas'
  | 'enable_canvas_control_bars_collapse'
  | 'enable_rep_app_visibility_order'
  | 'enable_file_sharing_print_permissions'
  | 'enable_section_sharing_print_permissions'
  | 'enable_marketplace_tab'
  | 'enable_sfdc_account_visibility_for_canvases'
  | 'sfdc_offline_enabled'
  | 'enable_granular_permissions'
  | 'enable_hub_collections'
  | 'enable_hub_recommended_smart_folder'
  | 'enable_custom_user_properties'

export type LaunchDarklyNumberFlagKey =
  | 'canvas_section_selector_page_size'
  | 'canvas_section_selector_selected_items_with_thumbnail_size'

/** How PIA Search serves inference (PIT-6863). */
export type PiaSearchMode = 'off' | 'on_device' | 'online'

/**
 * `pia_search_config` LD flag value — selects how PIA Search serves inference.
 * Object-valued (not a bare boolean) so the mode can grow sibling config later
 * without a second flag; `mode` is the only field today.
 */
export type PiaSearchConfig = {
  mode?: PiaSearchMode
}

/**
 * Resolve the PIA Search mode from the `pia_search_config` flag: a valid `mode`
 * wins; anything missing or invalid resolves to `'off'` (fail-closed).
 */
export function resolvePiaSearchMode(config: PiaSearchConfig | null | undefined): PiaSearchMode {
  if (config?.mode === 'off' || config?.mode === 'on_device' || config?.mode === 'online') return config.mode
  return 'off'
}

type LaunchDarklyObjectFlags = {
  canvas_manager_table_columns: CanvasManagerTableColumns
  context_crm_shape: Record<string, any>
  pia_search_config: PiaSearchConfig
}

export type LaunchDarklyObjectFlagKey = keyof LaunchDarklyObjectFlags
export type LaunchDarklyStringFlagKey = keyof typeof _LaunchDarklyStringFlags
const _LaunchDarklyStringFlags = {
  canvas_component_grouping: ['page', 'page_break', 'none'],
  batch_open_content_grid_ar_files: ['off', 'simultaneous', 'swap'],
  selectors_dnd_batch_add_style: ['button', 'buttons', 'dropdown'],
  pspdfkit_client_version: ['', 'pspdfkit-web/2024.6.0/pspdfkit.js', 'pspdfkit-web/1.14.0/nutrient-viewer.js'], // path suffix appended to file.pspdfkit_server_url; empty → legacy 2024.6.0/pspdfkit.js
  slotty_ui_remote_script_url: ['https://anyvalidurl.xyz', ''], // empty string means no remote script
  dsr_remote_script_url: ['https://anyvalidurl.xyz', ''], // empty string means no remote script
  ai_image_generation_model: ['minimax/image-01', ''], // empty string means minimax/image-01
  ai_video_generation_model: ['minimax/video-01', ''], // empty string means minimax/video-01
  sharebox_format: ['content-grid', 'content-grid-default', 'collection-player-default'],
} as const

type LaunchDarklyStringFlagValue<K extends LaunchDarklyStringFlagKey = LaunchDarklyStringFlagKey> =
  K extends LaunchDarklyStringFlagKey ? (typeof _LaunchDarklyStringFlags)[K][number] : never

type CanvasManagerVisibility = {
  hide: string[]
  order: string[]
}

export type CanvasTablePagination = {
  sizes: number[]
  default: number
}

export type CanvasManagerTableColumns = {
  canvas_templates: CanvasManagerVisibility
  canvases: CanvasManagerVisibility
  section_templates: CanvasManagerVisibility
  sections: CanvasManagerVisibility
}

export type LaunchDarklyEnv = {
  [K in LaunchDarklyBooleanFlagKey]?: boolean
} & {
  [K in LaunchDarklyStringFlagKey]?: LaunchDarklyStringFlagValue<K>
} & {
  [K in LaunchDarklyNumberFlagKey]?: number
} & {
  [K in keyof LaunchDarklyObjectFlags]?: LaunchDarklyObjectFlags[K]
} & {
  [key: string]: any
}
